import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editCostBy = ( {data, costById} : {data: IPostEditCostBy | {}, costById: number}): Promise<string> => {
  return axiosDefaultApi.put(`api/CostBy/UpdateCostBy/${costById}`, data);
};

type QueryFnType = typeof editCostBy;

type UseEditCostByOptions = {
  data: IPostEditCostBy | {};
  costById: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditCostBy = ({ config }: UseEditCostByOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της παραμέτρου 'Κόστος ανά'.`, 500);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllCostBy"])
            addNotification(`Η παράμετρος 'Κόστος ανά' Ενημερώθηκε`, 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editCostBy,
    })
}